import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

interface TextFieldProps {
  contextName: string;
  rules: any;
  label: string;
  inputProps: any;
}

export default function TextField({
  contextName,
  rules,
  label,
  inputProps,
}: TextFieldProps) {
  return (
    <FormFieldController name={contextName} rules={rules}>
      {({ field, fieldState }) => {
        return (
          <FormField
            label={label}
            error={fieldState.error?.message?.toString()}
            type="text"
            inputProps={{ ...inputProps, ...field }}
            value={field.value}
          />
        );
      }}
    </FormFieldController>
  );
}
